import * as Tone from 'tone';

const COUNTDOWN_CONFIG = {
    INITIAL_COUNT: 3,
    INTERVAL_MS: 1000,
    FINAL_DELAY_MS: 500,
    START_TEXT: 'Старт!'
};

let countdownSynth;
let currentCountdownResolve = null;
let currentCountdownInterval = null;
let currentCountdownTimeout = null;

function getCountdownSynth() {
    if (countdownSynth) return countdownSynth;

    try {
        countdownSynth = new Tone.Synth({
            oscillator: { type: 'triangle' },
            envelope: { attack: 0.001, decay: 0.1, sustain: 0.1, release: 0.15 }
        }).toDestination();
    } catch (error) {
        console.warn('Не удалось создать синт для обратного отсчета:', error);
        countdownSynth = null;
    }

    return countdownSynth;
}

function playCountdownBeep() {
    // Создаем звук удара двух барабанных палочек друг о друга - сухой, короткий щелчок
    try {
        // Основной щелчок - короткий импульс шума с высокочастотным фильтром
        const noise = new Tone.Noise('white').start();
        const filter = new Tone.Filter({
            frequency: 3000, // Более высокая частота для щелчка палочек
            type: 'bandpass',
            Q: 4 // Более узкий диапазон для сухого звука
        });
        const envelope = new Tone.AmplitudeEnvelope({
            attack: 0.001, // Очень быстрая атака
            decay: 0.05, // Быстрый спад для короткого щелчка
            sustain: 0,
            release: 0.03 // Очень короткий релиз
        });
        
        noise.connect(envelope);
        envelope.connect(filter);
        filter.toDestination();
        
        envelope.triggerAttackRelease(0.08); // Очень короткий звук
        
        // Добавляем высокочастотный тональный щелчок для четкости
        const click = new Tone.Oscillator({
            type: 'sine',
            frequency: 800 // Более высокая частота для щелчка
        });
        const clickGain = new Tone.Gain(0.2); // Тише, чтобы не доминировать
        const clickEnvelope = new Tone.AmplitudeEnvelope({
            attack: 0.001,
            decay: 0.03,
            sustain: 0,
            release: 0.02
        });
        
        click.connect(clickEnvelope);
        clickEnvelope.connect(clickGain);
        clickGain.toDestination();
        
        click.start();
        clickEnvelope.triggerAttackRelease(0.05);
        click.stop('+0.05');
        
        // Останавливаем и очищаем ресурсы после воспроизведения
        setTimeout(() => {
            noise.stop();
            noise.dispose();
            filter.dispose();
            envelope.dispose();
            click.dispose();
            clickGain.dispose();
            clickEnvelope.dispose();
        }, 150); // Короче таймаут для более быстрой очистки
    } catch (error) {
        console.warn('Не удалось воспроизвести сигнал обратного отсчета:', error);
    }
}

function createCountdownContainer() {
    const container = document.createElement('div');
    container.className = 'countdown-overlay';
    container.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
        font-size: 120px;
        color: white;
        font-weight: bold;
    `;
    return container;
}

export async function startCountdown(options = {}) {
    const {
        initialCount = COUNTDOWN_CONFIG.INITIAL_COUNT,
        intervalMs = COUNTDOWN_CONFIG.INTERVAL_MS,
        finalDelayMs = COUNTDOWN_CONFIG.FINAL_DELAY_MS,
        startText = COUNTDOWN_CONFIG.START_TEXT,
        speedFactor = 1
    } = options;

    // Останавливаем предыдущий countdown, если он активен
    stopCountdown();

    return new Promise((resolve, reject) => {
        // Не создаем и не показываем окно отсчета
        // Только воспроизводим звуки тика

        let count = initialCount;
        const effectiveSpeed = speedFactor > 0 ? speedFactor : 1;
        // Интервал тика зависит только от скорости: без лишнего деления на 2
        const tickInterval = intervalMs / effectiveSpeed;

        // Сохраняем resolve и reject для возможности отмены
        currentCountdownResolve = { resolve, reject };

        // Воспроизводим первый тик
        playCountdownBeep();

        currentCountdownInterval = setInterval(() => {
            // Проверяем, не была ли отмена
            if (!currentCountdownResolve) {
                clearInterval(currentCountdownInterval);
                currentCountdownInterval = null;
                return;
            }

            count--;

            if (count > 0) {
                playCountdownBeep();
            } else {
                // Последний тик на "Старт!"
                playCountdownBeep();
                currentCountdownTimeout = setTimeout(() => {
                    if (currentCountdownResolve) {
                        clearInterval(currentCountdownInterval);
                        currentCountdownInterval = null;
                        currentCountdownTimeout = null;
                        const resolveFn = currentCountdownResolve.resolve;
                        currentCountdownResolve = null;
                        resolveFn();
                    }
                }, finalDelayMs);
            }
        }, tickInterval);
    });
}

// Принудительная остановка/скрытие обратного отсчёта,
// используется при stopBlockPlayback.
export function stopCountdown() {
    try {
        // Останавливаем интервал и таймаут
        if (currentCountdownInterval) {
            clearInterval(currentCountdownInterval);
            currentCountdownInterval = null;
        }
        if (currentCountdownTimeout) {
            clearTimeout(currentCountdownTimeout);
            currentCountdownTimeout = null;
        }
        // Отклоняем Promise, чтобы код после await startCountdown() не выполнился
        if (currentCountdownResolve) {
            currentCountdownResolve.reject(new Error('Countdown stopped'));
            currentCountdownResolve = null;
        }

        // Скрываем overlay, если есть
        const overlays = document.querySelectorAll('.countdown-overlay');
        overlays.forEach(el => {
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            }
        });
    } catch (e) {
        console.warn('Ошибка при остановке обратного отсчета:', e);
    }
}

export { COUNTDOWN_CONFIG };
